"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.list = void 0;
const constants_1 = require("../constants");
function list({ groupId, withStats, }) {
    return {
        method: 'GET',
        params: {
            withStats,
        },
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/topics/list`,
    };
}
exports.list = list;
function create({ groupId, displayName, }) {
    return {
        method: 'POST',
        data: { displayName },
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/topics/create`,
    };
}
exports.create = create;
//# sourceMappingURL=http.js.map